import { useState } from "react";

export const useStockDialogs = () => {
  const [isRestockDialogOpen, setIsRestockDialogOpen] = useState(false);
  const [isLossDialogOpen, setIsLossDialogOpen] = useState(false);
  const [isReturnDialogOpen, setIsReturnDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const handleRestockClick = (item: any) => {
    setSelectedItem(item);
    setIsRestockDialogOpen(true);
  };

  const handleReturnClick = (item: any) => {
    setSelectedItem(item);
    setIsReturnDialogOpen(true);
  };

  const handleLossClick = () => {
    setIsLossDialogOpen(true);
  };

  return {
    isRestockDialogOpen,
    setIsRestockDialogOpen,
    isLossDialogOpen,
    setIsLossDialogOpen,
    isReturnDialogOpen,
    setIsReturnDialogOpen,
    selectedItem,
    setSelectedItem,
    handleRestockClick,
    handleReturnClick,
    handleLossClick,
  };
};